import React from 'react'
import type { Report } from '../api/report'

interface AdminReportDetailModalProps {
  report: Report
  onClose: () => void
  formatDate: (dateString: string) => string
  getReasonLabel: (reason: string) => string
}

const AdminReportDetailModal: React.FC<AdminReportDetailModalProps> = ({
  report,
  onClose,
  formatDate,
  getReasonLabel,
}) => {
  return (
    <div className="p-24px">
      <div className="flex gap-24px mb-24px">
        {report.user?.profile_image && (
          <div className="flex-shrink-0">
            <img
              src={report.user.profile_image}
              alt="프로필"
              className={`
                w-120px
                h-120px
                rounded-12px
                object-cover
                border
                border-brandPrimary-10%
              `}
            />
          </div>
        )}
        <div className="flex-1 grid grid-cols-2 gap-16px">
          <div>
            <label className="text-style-labelS text-textColorText2 mb-4px block">
              신고 ID
            </label>
            <div className="text-style-body2 text-textColorText2">
              {report.id}
            </div>
          </div>

          <div>
            <label className="text-style-labelS text-textColorText2 mb-4px block">
              신고자
            </label>
            <div className="text-style-body2 text-textColorText2">
              {report.user?.nickname || report.user?.username || '-'}
            </div>
          </div>

          <div>
            <label className="text-style-labelS text-textColorText2 mb-4px block">
              신고 사유
            </label>
            <div className="text-style-body2 text-textColorText2">
              {getReasonLabel(report.reason)}
            </div>
          </div>

          <div>
            <label className="text-style-labelS text-textColorText2 mb-4px block">
              신고일
            </label>
            <div className="text-style-body2 text-textColorText2">
              {formatDate(report.created_at)}
            </div>
          </div>
        </div>
      </div>

      {report.description && (
        <div className="mb-24px">
          <label className="text-style-labelS text-textColorText2 mb-4px block">
            상세 설명
          </label>
          <div className="text-style-body2 text-textColorText2 whitespace-pre-wrap break-words">
            {report.description}
          </div>
        </div>
      )}

      {report.review && (
        <div className="mb-24px p-16px bg-backgroundColorBg2 rounded-8px">
          <label className="text-style-labelS text-textColorText2 mb-12px block">
            신고된 리뷰 정보
          </label>
          <div className="grid grid-cols-2 gap-16px mb-16px">
            <div>
              <label className="text-style-labelS text-textColorText2 mb-4px block">
                리뷰 ID
              </label>
              <div className="text-style-body2 text-textColorText2">
                {report.review.id}
              </div>
            </div>

            <div>
              <label className="text-style-labelS text-textColorText2 mb-4px block">
                리뷰 작성자
              </label>
              <div className="text-style-body2 text-textColorText2">
                {report.review.user?.nickname ||
                  report.review.user?.username ||
                  '-'}
              </div>
            </div>

            <div>
              <label className="text-style-labelS text-textColorText2 mb-4px block">
                장소
              </label>
              <div className="text-style-body2 text-textColorText2">
                {report.review.place?.name || '-'}
              </div>
            </div>

            <div>
              <label className="text-style-labelS text-textColorText2 mb-4px block">
                주소
              </label>
              <div className="text-style-body2 text-textColorText2">
                {report.review.place?.address || '-'}
              </div>
            </div>
          </div>

          <div>
            <label className="text-style-labelS text-textColorText2 mb-4px block">
              리뷰 내용
            </label>
            <div className="text-style-body2 text-textColorText2 whitespace-pre-wrap break-words">
              {report.review.review_text || '-'}
            </div>
          </div>
        </div>
      )}

      <div className="flex justify-end mt-24px pt-24px border-t border-brandPrimary-5%">
        <button
          onClick={onClose}
          className={`
            py-10px
            px-20px
            bg-4B3621-80%
            text-white
            rounded-8px
            text-style-button2
            hover:bg-4B3621-80%-70%
            transition-colors
          `}
        >
          닫기
        </button>
      </div>
    </div>
  )
}

export default AdminReportDetailModal
